<template>
  <div>
    <van-cell v-for="(item, key) in person" :key="key" :title="item.name" is-link :value="item.status ? '': '已评价'" @click="goTo(item)"/>
  </div>
</template>
  
<script>
  export default {
    data() {
      return {
        person: [
          { name: '阮洋', userId: '20210034', status: true },
          { name: '傅璟', userId: '20211297', status: true },
          { name: '王伟峰', userId: '20211395', status: true },
          { name: '孙家兴', userId: '20211722', status: true },
          { name: '胡石军', userId: '20211737', status: true },
          { name: '徐绍殷', userId: '20211467', status: true },
          { name: '黄悦凯', userId: '20211734', status: true },
          { name: '陈豪杰', userId: '20211647', status: true },
          { name: '赵赛君', userId: '20220074', status: true },
          { name: '谢贞云', userId: '2017205', status: true },
          { name: '吴昌悦', userId: '2017551', status: true },
          { name: '高伟荣', userId: '20210845', status: true },
          { name: '梁泳梅', userId: '20200930', status: true },
          { name: '陈柏光', userId: '20220610', status: true }
        ],
        name: '',
        userId: ''
      }
    },
    mounted() {
      // console.log(this.$route.query)
      // const test = {"errno":1,"data":{"errcode":1,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":1,"extattr":{"attrs":[{"name":"英文名","value":"","type":1,"text":{"value":""}},{"name":"工号","value":"2017551","type":1,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":1,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":1,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
      // this.WXInfo = test.data
      this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
      this.name = this.WXInfo.name
      this.userId = this.WXInfo.userid
      this.date = this.$route.query.date
      this.getData()
    },
    methods: {
      goTo(item) {
        this.$router.push('/appraise/index?user=' + item.name + '&id=' + item.userId + '&status=' + item.status + '&date=' + this.date)
      },
      async getData() {
        const result = await this.$request({
          url: '/api/GeneralMethod/getFunctionList',
          method: 'GET',
          params: {
            Model: 'appraise',
            dateTime: this.date,
            userId: this.userId
          }
        })
        result.data.forEach(ele => {
          const index = this.person.findIndex(item => ele.appraisedId === item.userId)
          if (index >= 0) {
            this.person[index].status = false
          }
        })
      }
    }
  }
</script>
  
<style>
  #app {
    height: auto;
    /* background: #FFFFFF; */
  }
  .top-message{
    text-align: center;
    margin-top: 5%;
  }
</style>
  